export default "__VITE_ASSET__BgEsSm0C__"